import type { TTicketAuditLogAction } from "models/auditLogs";

export const RECEIVER_ACTIONS: TTicketAuditLogAction[] = [
	"AccessRequestApproved",
	"AccessRequestAutomaticApproved",
	"AccessRequestForwarded",
	"AccessRequestPassedApprovalFlowStep",
	"AccessRequestPermissionAlreadyExist",
	"AccessRequestPermissionExpiredRevokedFailure",
	"AccessRequestPermissionExpiredRevokedSuccess",
	"AccessRequestPermissionGrantedFailure",
	"AccessRequestPermissionGrantedSuccess",
	"AccessRequestPermissionRetryGrant",
	"AccessRequestPermissionRetryRevoke",
	"AccessRequestPermissionRetryRevoke",
	"AccessRequestPermissionReverted",
	"AccessRequestPermissionTryGrant",
	"AccessRequestPermissionTryRevert",
	"AccessRequestPermissionTryRevoke",
	"AccessRequestPermissionWontRevoke",
	"AccessRequestRedirectedToAdminDisabledWebhook",
	"AccessRequestRedirectedToAdminEmptyGroup",
	"AccessRequestRedirectedToAdminNoManager",
	"AccessRequestRedirectedToAdminNoTeamMembers",
	"AccessRequestStatusChanged",
	"AccessRequestTaskCreated",
	"AccessRequestApproverExpired"
];
export const USER_ACTION_TYPES = ["userApproved", "userDeclined", "redirect.toUser"];
export const TRANSLATION_PREFIX = "common.ticketActivity.ticketActivityItem.";
export const TICKET_AUDIT_LOGS_WITH_POSSESSIVE_FORM = [
	"AccessRequestPassedApprovalFlowStep",
	"AccessRequestPermissionExpiredRevokedSuccess",
	"AccessRequestPermissionReverted",
	"AccessRequestPermissionWontRevoke"
];
